import { createSlice } from "@reduxjs/toolkit";

/**
 * modal 전역 상태 초기값
 * - MODAL_INIT_OPENED : 현재 열린 모달 스택 배열
 */
const initialState = {
    MODAL_INIT_OPENED: [],
};

/**
 * modal Redux Slice
 * - 모달 열기/닫기/상태 제어 관리
 */
const modalSlice = createSlice({
    name: "modal",
    initialState,
    reducers: {
        /**
         * 모달 추가
         * - 모달 스택에 새로운 모달 push
         * @param {Object} state - 현재 state
         * @param {Object} action - Redux action 객체
         */
        openModal(state, action) {
            const config = action.payload || {};
            const modalProps = config.modalProps || {};

            state.MODAL_INIT_OPENED.push({
                modalProps,
                title: modalProps.title,
                component: config.component,
                closeFunc: config.closeFunc || null,
                confirmFunc: config.confirmFunc || null,
                isFirst: config.isFirst,
                visible: false,
            });
        },

        /**
         * 마지막 모달 제거
         * - 모달 스택 마지막 요소 제거
         * @param {Object} state - 현재 state
         */
        popModal(state) {
            state.MODAL_INIT_OPENED.pop();
        },

        /**
         * 마지막 모달 visible 상태 변경
         * @param {Object} state - 현재 state
         * @param {Object} action - Redux action 객체
         */
        setModalState(state, action) {
            const list = state.MODAL_INIT_OPENED;
            const lastIdx = list.length - 1;
            if (lastIdx < 0) return;

            list[lastIdx] = {
                ...list[lastIdx],
                visible: !!action.payload,
            };
        },
    },
});

export const { openModal, setModalState, popModal } = modalSlice.actions;
export default modalSlice.reducer;